.jb-input-web-component{
    --jb-input-input-direction: ltr;

}